
import { useEffect, useState } from 'react'
import { onValue, ref, get } from 'firebase/database'
import { db } from '../../firebase'
import { formatWebData } from '../helpers/formatWebData'

export const useFetchData = () => {
    const [state, setState] = useState({
        data: formatWebData(),
        isLoading: true,
        errors: null
    })

    const getFetch = async () => {
        try{
            const listnerRef = ref(db, 'PV_Southern/Blasting_Panel/Address/0/Fields')


            const brightnessSnap = await get(ref(db, 'PV_Southern/Blasting_Panel/Address/0/Brightness'))
            let brightnessData = {}
            if (brightnessSnap.exists()) {
                const val = brightnessSnap.val()
                brightnessData = {
                    brightnessDay: val.Day,
                    brightnessNight: val.Night
                }
            }

            const brightnessValues = await get(ref(db, 'PV_Southern/Blasting_Panel/Brightness'))
            let brightnessVal = {}
            if (brightnessValues.exists()) {
                const val = brightnessValues.val()
                brightnessVal = {
                    brightnessDayHigh: val.Day.Strong,
                    brightnessDayMedium: val.Day.Intermediate,
                    brightnessDayLow: val.Day.Low,
                    brightnessNightHigh: val.Night.Strong,
                    brightnessNightMedium: val.Night.Intermediate,
                    brightnessNightLow: val.Night.Low,
                }
            }

            onValue(listnerRef, (snapshot) => {
                if(snapshot.exists()){
                    const datos = formatWebData(snapshot.val())
                    setState({
                        data: { ...datos, ...brightnessData, ...brightnessVal },
                        isLoading: false,
                        errors: null
                    })
                } else{
                    console.error("no existe database")
                    setState({
                        data: null,
                        isLoading: false,
                        errors: null
                    })
                }
        
            })
    
        } catch(error) {
            console.error(error)
            setState({
                data: null,
                isLoading: false,
                errors: null
            })
        }
    }


    useEffect(() => {
        getFetch()
    }, [])

    return state
}
